import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=8eabbbe6&lang=pug&"
import script from "./Post.vue?vue&type=script&lang=ts&"
export * from "./Post.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports